/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConsoleTransport } from "./consoleTransport";
import { HttpTransport } from "./httpTransport";

export { ConsoleTransport, HttpTransport };

export type Level = "warn" | "info" | "error" | "debug";

export type Transport = ConsoleTransport | HttpTransport;

const logLevels: Level[] = ["error", "warn", "info", "debug"];

export class Logger {
  transports: Transport[] = [];
  getContextDataFn: () => Record<string, unknown>;

  constructor(transports: Transport[] = [], getContextDataFn: () => Record<string, unknown>) {
    this.transports = transports;
    this.getContextDataFn = getContextDataFn;
  }

  public extendErrorDataFromMeta(meta: any) {
    if (!meta.length) return;
    for (const m of meta) {
      if (m instanceof Error) {
        meta = { ...this.parseErrorFromMeta(m), ...meta };
      } else if (typeof m === "object") {
        meta = { ...this.parseMetadataObject(m), ...meta };
      }
    }
    return meta;
  }

  public error(message: string, ...meta: any) {
    return this.send("error", message, ...meta);
  }

  public warn(message: string, ...meta: any) {
    return this.send("warn", message, ...meta);
  }

  public info(message: string, ...meta: any) {
    return this.send("info", message, ...meta);
  }

  public debug(message: string, ...meta: any) {
    return this.send("debug", message, ...meta);
  }

  private parseMetadataObject(meta: Record<string, any>) {
    for (const key in meta) {
      if (meta[key] instanceof Error) {
        return this.parseErrorFromMeta(meta[key]);
      }
    }
  }

  private parseErrorFromMeta(error: Error) {
    const errorMessage = error?.message;
    const errorStack = error?.stack;
    return { errorMessage, errorStack };
  }

  private shouldLog(level: Level) {
    return logLevels.includes(level);
  }

  private send(level: Level, message: string, ...meta: any) {
    if (!this.shouldLog(level)) return;
    try {
      {
        const formatedMeta = this.extendErrorDataFromMeta(meta);
        this.transports.forEach((transport) => {
          transport[level](message, { ...formatedMeta, context: this.getContextDataFn() });
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
}
